<template>
  <v-container fluid id="tips-container">
    <v-row class="tip-wrapper">
      <v-col cols="12" class="company-logo" align-self="center">
        <a :href="`/${companyUrl}`" target="_self">
          <img
            class="d-block m-auto"
            :src="company.CompanyLogoLink"
            :alt="company.Name"
          />
        </a>
      </v-col>
      <v-col cols="12" class="logo-seperator pa-0 pb-2"></v-col>
      <v-col cols="12" class="company-name px-6">
        <span class="primary--text display-24-18">{{
          company.NameInHebrew
        }}</span>
      </v-col>
      <v-row class="sector-and-industry px-6">
        <v-col cols="6" class="display-16" v-if="company.Industry">
          <span class="sector-title bold">{{
            getString(constants, 'CompaniesLobby_PromotedCompany_Industry')
              .Value
          }}</span>
          <div class="sector">{{ company.Industry }}</div>
        </v-col>

        <v-col cols="6" class="display-16" v-if="company.NumberOfEmployees">
          <span class="number-of-employees-title bold">{{
            getString(
              constants,
              'CompaniesLobby_PromotedCompany_NumberOfEmployees'
            ).Value
          }}</span>
          <div class="number-of-employees">{{ company.NumberOfEmployees }}</div>
        </v-col>
      </v-row>
      <v-col cols="12" class="benefits-title display-16 px-6 pb-0">
        <span class="fonr-weight-bold" v-show="company.Benefits.length > 0">{{
          getString(constants, 'CompaniesLobby_PromotedCompany_Benefits').Value
        }}</span>
      </v-col>

      <v-col cols="12" class="benefits py-0">
        <div
          v-show="company.Benefits.length > 0"
          class="d-inline-block"
          v-for="(item, index) in company.Benefits.slice(0, 4)"
          :key="index"
        >
          <v-chip class="ma-2">{{ item.Name }}</v-chip>
        </div>
      </v-col>
      <v-col
        cols="12"
        class="px-6 d-flex"
        align-self="end"
        justify-self="center"
      >
        <v-btn :to="`/${companyUrl}`" color="primary" target="_self" rounded>{{
          getString(constants, 'CompaniesLobby_PromotedCompany_AllInfo').Value
        }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CompanyUrl from './mixins/CompanyUrl.js'

export default {
  mixins: [CompanyUrl],
  data() {
    return {}
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    constants: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
#tips-container {
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  height: 440px;
  background-color: white;
  width: 95%;
}

#tips-container:hover {
  -webkit-box-shadow: rgb(0 0 0 / 15%) 0 0 2px 2px;
  box-shadow: rgb(0 0 0 / 15%) 0 0 2px 2px;
}

.company-logo {
  height: 75px;
}

.logo-seperator {
  border-top: 1px solid #e7e8ea;
}

.company-name {
  height: 70px;
  overflow: hidden;
  line-height: 1.2;
}

.sector-and-industry {
  height: 72px;
}

.benefits-title {
  height: 36px;
}

.benefits {
  height: 96px;
  overflow: hidden;
}
</style>
